import { createAction } from "@reduxjs/toolkit";
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["authenticate"] = "user/authenticate";
    ActionTypes["logOut"] = "user/logOut";
})(ActionTypes || (ActionTypes = {}));
export const actions = {
    authenticate: createAction(ActionTypes.authenticate, () => ({
        payload: {}
    })),
    logOut: createAction(ActionTypes.logOut, () => ({
        payload: {}
    }))
};
